import type { RouteRecordRaw } from 'vue-router'

export const CancelContractRoutes: Array<RouteRecordRaw> = [
  {
    path: '/automatic-renewal',
    meta: { middleware: 'auth', requiresAuth: true },
    component: () => import('@/layouts/dashboard-layout/index.vue'),
    children: [
      {
        path: '',
        name: 'first-step-cancel-contract',
        component: () => import('@/views/contract/automatic-renewal.vue')
      },
      {
        path: 'cancel-reason/:reason',
        name: 'second-step-cancel-contract',
        component: () => import('@/views/contract/cancel-reason.vue'),
        props: (route) => ({ reason: route.params.reason })
      },
      {
        path: 'cancel-contract-seccussfully/:expireAt',
        name: 'final-step-cancel-contract',
        component: () => import('@/views/contract/cancel-contract-successfully.vue'),
        props: (route) => ({ expireAt: route.params.expireAt })
      },
      {
        path: 'getting-special-offer/:discount/:price',
        name: 'special_offer',
        component: () => import('@/views/contract/getting-special-offer.vue'),
        props: (route) => ({
          discount: route.params.discount,
          price: route.params.price
        })
      }
    ]
  }
]
